// Picks AdminDashboard (admin overview — Screen 1) vs EmployeeDashboard
// (employee portal — Screen E1) based on the caller's role.

import React from "react";
import AdminDashboard from "./AdminDashboard";
import EmployeeDashboard from "./EmployeeDashboard";

export default function DashboardRouter() {
  const role = localStorage.getItem("role");
  return role === "SUPER_ADMIN" ? <AdminDashboard /> : <EmployeeDashboard />;
}
